import { useMemo } from "react";
import qs from "qs";

import HeaderContent from "../pages/Homepage/components/HeaderContent";
import LandingTypography from "../pages/Homepage/components/LandingTypography";
import PremiumPlanBoxContent from "../pages/Homepage/components/PremiumPlanBoxContent";
import HeaderContentPromotion from "../pages/Homepage/components/promotion/HeaderContentPromotion";
import PromotionPlanBanner from "../pages/Homepage/components/promotion/PromotionPlanBanner";
import PromotionPremiumPlanBoxContent from "../pages/Homepage/components/promotion/PromotionPremiumPlanBoxContent";
import PromotionToggleSelectPlan from "../pages/Homepage/components/promotion/PromotionToggleSelectPlan";
import ToggleSelectPlan from "../pages/Homepage/components/ToggleSelectPlan";
import HeaderImageDesktopDefault from "../pages/Homepage/assets/macbook_pro_1.png";
import {
  getIsBlackFridayDay,
  getIsBlackWeekend
} from "../../../../lib/getIsBlackFriday";
import BlackFridayLandingTypography from "../pages/Homepage/components/blackFriday/BlackFridayLandingTypography";
import BlackFridayPlanBanner from "../pages/Homepage/components/blackFriday/BlackFridayPlanBanner";
import HeaderContentBlackFriday from "../pages/Homepage/components/blackFriday/HeaderContentBlackFriday";
import BlackFridayToggleSelectPlan from "../pages/Homepage/components/blackFriday/BlackFridayToggleSelectPlan";
import BlackFridayPremiumPlanBoxContent from "../pages/Homepage/components/blackFriday/BlackFridayPremiumPlanBoxContent";
import BlackWeekPlanBanner from "../pages/Homepage/components/blackWeek/BlackWeekPlanBanner";
import HeaderContentBlackWeek from "../pages/Homepage/components/blackWeek/HeaderContentBlackWeek";
import BlackWeekToggleSelectPlan from "../pages/Homepage/components/blackWeek/BlackWeekToggleSelectPlan";
import BlackWeekPremiumPlanBoxContent from "../pages/Homepage/components/blackWeek/BlackWeekPremiumPlanBoxContent";

const isTimePromotion = (startTime, endTime) => {
  const now = new Date().getTime();

  return startTime && endTime && startTime <= now && now <= endTime;
};
const useTimedChanges = ({ translate }) => {
  const queryParams = useMemo(() => {
    return qs.parse(window.location.search, { ignoreQueryPrefix: true });
  }, []);

  const promotion = [
    Number(translate("lp_promo_start-time")),
    Number(translate("lp_promo_time"))
  ];

  const isPromotion = isTimePromotion(promotion[0], promotion[1]);

  const isBlackFriday = queryParams.v === "2" || getIsBlackFridayDay();
  const isBlackWeekend = queryParams.v === "3" || getIsBlackWeekend();

  if (isBlackFriday) {
    return {
      LandingTypography: BlackFridayLandingTypography,
      PlanBanner: BlackFridayPlanBanner,
      HeaderContent: HeaderContentBlackFriday,
      ToggleSelectPlan: BlackFridayToggleSelectPlan,
      TopBar: undefined,
      PremiumPlanBoxContent: BlackFridayPremiumPlanBoxContent,
      HeaderImageDesktop: HeaderImageDesktopDefault
    };
  }

  if (isBlackWeekend) {
    return {
      LandingTypography: BlackFridayLandingTypography,
      PlanBanner: BlackWeekPlanBanner,
      HeaderContent: HeaderContentBlackWeek,
      ToggleSelectPlan: BlackWeekToggleSelectPlan,
      TopBar: undefined,
      PremiumPlanBoxContent: BlackWeekPremiumPlanBoxContent,
      HeaderImageDesktop: HeaderImageDesktopDefault
    };
  }

  if (isPromotion) {
    return {
      LandingTypography: LandingTypography,
      PlanBanner: PromotionPlanBanner,
      HeaderContent: HeaderContentPromotion,
      ToggleSelectPlan: PromotionToggleSelectPlan,
      TopBar: undefined,
      PremiumPlanBoxContent: PromotionPremiumPlanBoxContent,
      HeaderImageDesktop: HeaderImageDesktopDefault
    };
  }

  return {
    LandingTypography: LandingTypography,
    PlanBanner: undefined,
    HeaderContent: HeaderContent,
    ToggleSelectPlan: ToggleSelectPlan,
    TopBar: undefined,
    PremiumPlanBoxContent: PremiumPlanBoxContent,
    HeaderImageDesktop: HeaderImageDesktopDefault
  };
};

export default useTimedChanges;
